// patch rax DOM

import {domReady} from "./utils";

export function patchRaxDOM() {
    domReady(() => {
        const _removeChild = document.body.removeChild;
        // @ts-ignore
        document.body.removeChild = (...arg: any[]) => {
            try {
                // @ts-ignore
                _removeChild.apply(this, arg);
            } catch(e) {
            }
        }
    });
}
